import defaultTheme from './defaultTheme';
const verizonTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#C92314', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#C92314', background: '#C92314' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#D22C1D' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#D22C1D', border: '#D22C1D', background: '#D22C1D' }), field: {
        focus: '#D22C1D',
        label: '#D22C1D',
        icon: '#D22C1D',
    } });
export default verizonTheme;
